export const FORM_LOCAL_STORAGE_KEY = "@Home/form-data";
export const PACKAGE_MODE_FLAG_KEY = "quero-caju-package-mode";

export const HYBRID_ROUTE_STEP_INDEX = 7;
